













































































import { Component, Vue, Prop } from "vue-property-decorator";
import { danwei, fuyong, jiliangdanwei } from "@/plugins/optionData";
@Component({})
export default class EdrDetailContentQitayongyao extends Vue {
  @Prop()
  private content: any;
  private danwei: any = danwei;
  private fuyong: any = fuyong;
  private jiliangdanwei: any = jiliangdanwei;
  /**
   * @description 获取store中的可编辑状态
   */
  private get ifCompose() {
    return this.$store.state.edrIfCompose;
  }
  /**
   * @description content双向绑定
   */
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  /**
   * @description 删除一个
   */
  private deleteOne(index) {
    this.content["value"]["饮片"].splice(index, 1);
    if (this.content["value"]["饮片"].length === 0) {
      this.content["value"]["饮片"].push({});
    }
  }
  /**
   * @description 增加一个
   */
  private addOne() {
    this.content["value"]["饮片"].push({});
  }
}
